export function fetchTitleAutocompleteResults(titleInput, autocompleteList, type) {
    if (!autocompleteList) return;

    const searchTerm = titleInput.value.trim();
    let url = `/drupal-content/api/nodes?q=${encodeURIComponent(searchTerm)}`;
    if (type) {
        url += `&type=${type}`;
    }
    fetch(url)
        .then(response => response.json())
        .then(data => {
            autocompleteList.innerHTML = '';

            if (data.length === 0) {
                autocompleteList.innerHTML = '<li class="no-select">No results found.</li>';
                return;
            }

            data.forEach(result => {
                const li = document.createElement('li');
                li.textContent = result.label;
                li.addEventListener('click', () => {
                    titleInput.value = result.label;
                    titleInput.setAttribute('node-nid', result.value);
                    autocompleteList.innerHTML = '';
                });
                autocompleteList.appendChild(li);
            });
        })
        .catch(error => {
            console.error('Error fetching autocomplete results:', error);
            autocompleteList.innerHTML = '<li>Error loading results</li>';
        });
}

export function debounce(func, delay) {
    let timeoutId;
    return function (...args) {
        clearTimeout(timeoutId);
        timeoutId = setTimeout(() => func.apply(this, args), delay);
    };
}
